module.exports = __webpack_public_path__ + "img/j.cf2b03ad.png";